document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined") {
    new Swiper(".result-swiper", {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 50,
      mousewheel: {
        releaseOnEdges: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          slidesPerGroup: 2,
        },
        1280: {
          slidesPerView: 3.2,
          slidesPerGroup: 3,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
    });
  } else {
    console.error("Swiper is not loaded");
  }
});
